import { ThunkType } from "../../../../core/store/reducers";
import { printBankGuarantees } from "../api/printBankGuarantees";
import fileDownload from "js-file-download";
import { setDownloadFetchState } from "../bankguaranteesDataSlice";
import { BankGuaranteeData } from "../types";

export const printBankGuaranteesThunk = (bankgurantee?: BankGuaranteeData): ThunkType => async (dispatch, getStore) => {
	const store = getStore();

	if (store.data.auth.current.status !== "successful" || !bankgurantee || !bankgurantee.grntId) {
		return undefined;
	}
	const lan = store.ux.localization.language
	const filename = `BankGuaranteeConf_${bankgurantee.grntId}.pdf`
	const user = store.data.auth.current.user;
	dispatch(setDownloadFetchState({ type: "started" }));
	const bankguaranteesReport = await dispatch(printBankGuarantees(user, bankgurantee.grntId));
	if (bankguaranteesReport) {
		fileDownload(new Blob([bankguaranteesReport as any], { type: "application/pdf" }), filename);
	}
	dispatch(setDownloadFetchState({ type: "not-started" }));
};
